import axios from 'axios';

export type AgreementLimitType = 'INITIAL' | 'COUNT' | 'UNSCHEDULED';

export interface AgreementLimit {
  id: string;

  agreementType: AgreementLimitType;

  leader: boolean;

  duczSyndicateFreePercent: number;

  duczFoodMinimumValue: number;

  duczFoodMaximumValue: number;

  duczFreeMinimumValue: number;

  benefitSumPercent: number;

  totalReadjustmentPercent: number;

  modifiedDate: string;

  modifiedBy: {
    id: string;
    name: string;
  };
}

export default class AgreementLimitService {
  public static async getCurrentAgreementLimit(
    agreementType: AgreementLimitType,
    isLeader: boolean,
  ): Promise<AgreementLimit> {
    return axios.get('/api/agreement-limits/current', {
      params: {
        agreementType,
        isLeader,
      },
    }).then(({ data }) => data);
  }
}
